import React from 'react';

const SocialProofPopup = () => {
  return null;
};

export default SocialProofPopup;